import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={30}
      height={30}
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={15} cy={15} r={15} fill="#000" fillOpacity={0.5} />
      <Path
        d="M10 20.833c0 .917.75 1.667 1.667 1.667h6.666c.917 0 1.667-.75 1.667-1.667v-10H10v10zm10.833-12.5h-2.916l-.834-.833h-4.166l-.834.833H9.167V10h11.666V8.333z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
